<template>
  <a
    style="cursor:pointer;"
    v-clipboard="text"
    @success="onCopy"
    title="Copy to clipboard"
    class="t-secondary"
    @click.stop
  >
    <i class="fa fa-clipboard ml-1 mr-1 fade-alert" :class="{ 'fade-alert-in': isAnimating }"></i>
  </a>
</template>

<script>
/**
 * Shows up as a copy-icon. On click, the `text`-property is copied to the clipboard.
 * Example usage: <copy-icon :text="Hello world" />
 */
export default {
  name: 'CopyIcon',
  props: {
    text: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isAnimating: false
    }
  },
  methods: {
    onCopy () {
      this.isAnimating = true
      setTimeout(() => { this.isAnimating = false }, 800)
    }
  }
}
</script>
